var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#clip0_113_5403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.067 8.333V5.4c0-.81-.657-1.467-1.467-1.467h-3.911M6.378 3.933H2.467C1.657 3.933 1 4.59 1 5.4v16.133C1 22.343 1.657 23 2.467 23h5.866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.367 4.898c-.1.3-.38.502-.696.502H7.396a.734.734 0 0 1-.697-.502l-.977-2.933A.732.732 0 0 1 6.418 1h8.23a.732.732 0 0 1 .697.965l-.978 2.933z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.267h-8.733a1.5 1.5 0 0 0-1.5 1.5V21.5a1.5 1.5 0 0 0 1.5 1.5H21.5a1.5 1.5 0 0 0 1.5-1.5v-8.733a1.5 1.5 0 0 0-1.5-1.5zM14.2 14.2h5.867M14.2 17.133h5.867M14.2 20.067h2.2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.2aff803d.svg";
export { ForwardRef as ReactComponent };